<template>
  <div id="_user_password_factor_frame" class="q-px-md">
    <div class="init-password-frame rounded-borders">
      <div class="q-py-md q-mt-xl">
        您尚未设置密码，请先设置密码，该密码将用于系统登录
      </div>
      <q-input
        class="q-mb-md"
        filled
        dense
        type="password"
        label="请输入新的密码"
        maxlength="16"
        :error="!!password1ErrorMsg"
        :error-message="password1ErrorMsg"
        v-model="password1"
        no-error-icon
        counter
        @input="handlePassword1Change"
      />
      <q-input
        class="q-mb-md"
        filled
        dense
        type="password"
        label="请确认密码"
        maxlength="16"
        :error="!!password2ErrorMsg"
        :error-message="password2ErrorMsg"
        v-model="password2"
        no-error-icon
        counter
        @input="handlePassword2Change"
      />

      <q-btn
        flat
        class="full-width bg-primary text-white text-bold q-mt-md"
        style="height: 40px"
        :disable="notReadyToCommit"
        @click="updatePassword"
        :loading="loading"
      >
        确认
      </q-btn>
    </div>
  </div>
</template>

<script>
import AuthMixin from "./auth.mixin";
import { bindPassword } from "../../api/endpoints/auth/bindPassword";
export default {
  mixins: [AuthMixin],
  data() {
    return {
      password1: "",
      password1ErrorMsg: "",
      password2: "",
      password2ErrorMsg: "",
      loading: false,
    };
  },

  computed: {
    notReadyToCommit() {
      const {
        password1,
        password2,
        password1ErrorMsg,
        password2ErrorMsg,
      } = this;
      return (
        !password1.length ||
        !password2.length ||
        !!password1ErrorMsg.length ||
        !!password2ErrorMsg.length
      );
    },
  },

  methods: {
    handlePassword1Change(password) {
      const { password2 } = this;
      if (password.length < 8) {
        this.password1ErrorMsg = "密码至少包含8位";
      } else if (password.length > 16) {
        this.password1ErrorMsg = "密码不能超过16位";
      } else {
        this.password1ErrorMsg = "";
      }
    },
    handlePassword2Change(password) {
      if (password !== this.password1) {
        this.password2ErrorMsg = "两次输入的密码不一致";
      } else if (this.password1ErrorMsg) {
        this.password2ErrorMsg = this.password1ErrorMsg;
      } else {
        this.password2ErrorMsg = "";
      }
    },

    async updatePassword() {
      this.loading = true;
      try {
        if (this.password1 !== this.password2) throw Error("两次密码不一致");
        const response = await bindPassword(this.password1);
        if (response.status) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.$q.notify({
            type: "success",
            message: response.message,
          });
          this.resolveUserStatus();
        }
      } catch (err) {
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
